import { render } from "./SettingsWorkspaceInviteUsers.vue?vue&type=template&id=5dfc99dc"
import script from "./SettingsWorkspaceInviteUsers.vue?vue&type=script&lang=js"
export * from "./SettingsWorkspaceInviteUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__